import React, { useEffect, useState } from 'react';
import apiClient from '../../../api/apiClient';
import { LIVEUSERS } from '../../../utils/ApiEndPoint';
import { UserIcon } from "../../../utils/FontIcon";
import { HEARTBEAT, REMOVEHEARTBEAT } from '../../../utils/ApiEndPoint';
import { CreateUniqGoID, setSession, getSession, removeSession,convertNumberToKM } from '../../../utils/utils';

function LiveUserCount({ onlyNumber }) {
    const [liveUsers, setLiveUsers] = useState(1);
    const getLiveUsers = () => {
        apiClient.get(LIVEUSERS).then((response) => {
            if (response.status === 200) {
                setLiveUsers(response.data.liveVisitors || 1);
            }
        }).catch((error) => {
            console.error("Error fetching live users:", error);
        });
    };
    useEffect(() => {
        getLiveUsers();
        const interval = setInterval(() => {
            getLiveUsers();
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const sessionGoId = getSession('GOID');//CreateUniqGoID();
        const GOID = sessionGoId ? sessionGoId : CreateUniqGoID();
        apiClient.post(HEARTBEAT, { userId: GOID })
            .then((response) => {
                setSession('GOID', GOID);
            })
            .catch((error) => {
                console.error("Error sending heartbeat:", error);
            });

        const handleBeforeUnload = (event) => {
            const sessionGoId = getSession('GOID');
            removeSession('GOID');
            apiClient.post(REMOVEHEARTBEAT, { userId: sessionGoId })
                .then((response) => {
                    console.log("🚀 ~ file: Header.jsx:123 ~ apiClient.post ~ response:", response);
                })
                .catch((error) => {
                    console.error("Error removing heartbeat:", error);
                });
        };
        // window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            // window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        onlyNumber ? <span className='count'>{`${convertNumberToKM(liveUsers)}+`}</span> :
            <h5 className='mt-2 online-user'>
                <span className='online-txt'> <UserIcon style={{ color: '#0085f7' }} /> <span className='oneline-usertxt'>Online :</span> </span>
                <span className='activeuser-count'>{`${convertNumberToKM(liveUsers)}+`}</span><div className="circle"></div>
            </h5>

    );
}

export default LiveUserCount;
